<template>
  <div>
    <div class="card text-center">
      <b-row>
        <div class="col-lg-3">
          <b-list-groub class="row no-gutters h-100 d-flex align-items-center py-2">
            <b-list-group-item class="col-6 col-lg-12 px-2">
              <b-button block :variant="activityView == 'all' ? 'primary' : 'outline-primary'" @click="getAll()">{{
                $t("edu_courses.all") }}
              </b-button>
            </b-list-group-item>
          </b-list-groub>
        </div>
        <div class="col-lg-9">
          <b-list-group horizontal v-if="courses.length > 0" style="overflow-x: scroll"
            class="h-100 d-flex align-items-center py-2">
            <b-list-group-item v-for="course in courses" :key="course.id" class="col-auto" v-if="course.flixable != 1">
              <b-button-group>
                <b-button variant="outline-primary">
                  <b-form-checkbox @change="get()" v-model="selectedContentIds" :value="course.id">
                  </b-form-checkbox> </b-button><b-button :variant="activityView == course.id ? 'primary' : 'outline-primary'
                    " @click="courseClick(course.id)">
                  <span>{{ course.code }}-{{ course.name }}</span>
                </b-button>
              </b-button-group>
            </b-list-group-item>
          </b-list-group>
          <b-spinner v-else type="grow" label="Loading..." class="loading" />
        </div>
      </b-row>
    </div>
    <b-row v-if="item.type != 'master'">
      <b-col lg="2">
        <b-card class="text-center" style="height: 574px; overflow: auto">
          <template v-for="item in Types">
            <b-button :key="item.id" :variant="selectedType == item ? 'info' : 'outline-info'" block
              @click="selectType(item)">
              <feather-icon icon="PenToolIcon" class="amr-50" />
              <span class="align-middle"> {{ $t("activities." + item) }}</span>
            </b-button>
          </template>
        </b-card>
      </b-col>
      <b-col lg="10" v-if="isShowContent == 1">
        <b-row v-if="load == false">
          <template v-if="activities.length > 0">
            <b-col lg="3" v-for="item in activities" :key="item.id">
              <b-card border-variant="info" footer-tag="footer">
                <b-card-body>
                  <b-card-title>{{ item.name }}
                    <b-badge variant="success" v-if="item.bestGrade != '-'">{{ item.bestGrade }}/{{ item.grade
                      }}</b-badge></b-card-title>

                  <b-card-sub-title class="mb-2">
                    <span class="text-info"><feather-icon icon="PenToolIcon" class="mr-50" />
                      {{ $t("activities." + item.type) }}</span></b-card-sub-title>

                  <b-card-text style="height: 66px; overflow: hidden" v-html="item.name">
                  </b-card-text>
                </b-card-body>
                <b-list-group flush>
                  <b-list-group-item>{{ $t("edu_courses.start_in") }} :{{
                    item.start_date
                  }}</b-list-group-item>
                  <b-list-group-item>
                    {{ $t("edu_courses.end_in") }} :
                    {{ item.end_date }}</b-list-group-item>
                </b-list-group>
                <div v-if="item.questions.length > 0">
                  <b-button block :variant="`relief-info`" @click="startActivity(item)">
                    {{ $t("site.read") }}
                  </b-button>
                </div>
                <div v-else>
                  <b-button block disabled :variant="`relief-info`">
                    {{ $t("activities.no_questions_yet") }}
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </template>
          <template v-else>
            <b-col lg="3">
              <b-card border-variant="info" footer-tag="footer">
                <b-card-body>
                  <b-card-title><feather-icon icon="AlertOctagonIcon" />
                  </b-card-title>
                  <b-card-text style="height: 66px; overflow: hidden">
                    {{ $t("site.no_data_found") }}
                  </b-card-text>
                </b-card-body>

                <template #footer> </template>
              </b-card>
            </b-col>
          </template>
        </b-row>
        <b-spinner v-else type="grow" label="Loading..." class="loading" />

        <!-- <b-card class="text-center" style="height: 70vh"></b-card> -->
      </b-col>
      <b-col lg="10" v-if="isShowContent == 2">
        <forum-vue :item="item" />
      </b-col>
      <b-col lg="10" v-if="isShowContent == 3">
        <search-vue :item="item" />
      </b-col>
      <b-col lg="10" v-if="isShowContent == 4">
        <homework-vue :item="item" />
      </b-col>
      <b-col lg="10" v-if="isShowContent == 5">
        <exam-vue :item="item" />
      </b-col>
    </b-row>
    <master-vue v-else></master-vue>
  </div>
</template>

<script>
import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";
import BCardCode from "@/@core/components/b-card-code/BCardCode.vue";
import ActivitiesController from "@/Controllers/ActivitiesController";
import forumVue from "./components/forum.vue";
import searchVue from "./components/search.vue";
import homeworkVue from "./components/homework.vue";
import examVue from "./components/exam.vue";
import EduCoursesController from "@/Controllers/EduCoursesController";
import Auth from "@/Apis/Auth";
import MasterVue from "./components/Master.vue";
export default {
  components: {
    BCardActions,
    BCardCode,
    forumVue,
    searchVue,
    homeworkVue,
    examVue,
    MasterVue,
  },
  beforeDestroy() {
    localStorage.removeItem("activity_type");
    localStorage.removeItem("activity");
    localStorage.removeItem("course_id");
  },
  data() {
    return {
      selectedContentIds: [],
      courses: [],
      eduCourses: {},
      activities: [],
      selectedType: "",
      activityView: "all",
      isShowContent: 1,
      item: {},
      load: false,
      Types: ["forum", "homework", "short_search", "exam"],
    };
  },
  async created() {
    this.load = true;
    let flag = 0;
    this.$mobileTitle.label = this.$i18n.t('activities.activities');

    if (localStorage.getItem("activity_type") != null) {
      flag = 1;
      this.selectedType = localStorage.getItem("activity_type");
      this.selectedContentIds = [];
      this.selectedContentIds.push(localStorage.getItem("course_id"));
      this.activityView = localStorage.getItem("course_id");
    }
    if (JSON.parse(localStorage.getItem("activity")) != null) {
      this.startActivity(JSON.parse(localStorage.getItem("activity")));
      flag = 2;
    }
    this.eduProgram = Auth.CurrentEduProgram();

    const data =
      await new EduCoursesController().EduCourseProgramsActiveSemester({
        eduProgramId: this.eduProgram.id,
      });
    this.courses = data;
    if (flag != 1) {
      this.courses.forEach((element) => {
        this.selectedContentIds.push(element.id);
      });
    }
    if (flag != 2) {
      await this.get();
    }

    this.load = false;
  },
  watch: {
    $route(to, from) {
      localStorage.removeItem("activity_type");
      localStorage.removeItem("activity");
    },
  },
  methods: {
    courseClick(id) {
      this.selectedContentIds = [];
      this.selectedContentIds.push(id);
      this.activityView = id;
    },
    async getAll() {
      this.load = true;
      this.activityView = "all";
      this.selectedType = "";
      this.selectedContentIds = this.courses.map((a) => a.id);
      await this.get();
      this.load = false;
    },
    async get() {
      this.item = {};
      this.activities = [];
      this.isShowContent = 1;
      let queryTypes = [];
      this.load = true;
      if (this.selectedType != "") {
        // console.log(this.selectedType)
        queryTypes = [this.selectedType];
      } else {
        queryTypes = this.Types;
        // queryTypes.push("master");
      }
      // console.log(queryTypes);
      const data = await new ActivitiesController().getStudentActivities({
        edu_course_ids: this.selectedContentIds,
        types: queryTypes,
        with: ["questions", "user"],
      });
      data.activities.forEach((activity) => {
        const questions_ids = activity.questions.map((question) => question.id);
        const activity_answers = data.user_answers.filter((element) => {
          return questions_ids.includes(element.activity_question_id);
        });
        activity.bestGrade = this.best_grade(activity.grade, activity_answers);
      });
      this.activities = data.activities;
      console.log("ho", this.activities);
      this.load = false;
    },
    // best_grade(activity_grade, answers) {
    //   let grades = [];
    //   for (let i = 1; i <= 3; i++) {
    //     let correct_flag = 0;
    //     let mygrade = 0;
    //     const results = answers.filter((element) => {
    //       return element.answer_number == i;
    //     });
    //     if (results.length > 0) {
    //       results.map((el) => {
    //         if (el.grade != null) {
    //           correct_flag = 1;
    //           mygrade += el.grade;
    //         }
    //       });
    //       console.log(mygrade);
    //       grades.push(
    //         correct_flag == 0
    //           ? null
    //           : ((mygrade / results.length) * (activity_grade / 100)).toFixed(2)
    //       );
    //     }
    //   }
    //   if (grades.every((element) => element === null)) {
    //     return "-";
    //   }
    //   console.log(grades);
    //   return Math.max(...grades);
    // },
    best_grade(activity_grade, answers) {
      const grades = [];

      // Loop through answer numbers 1 to 3
      for (let i = 1; i <= 3; i++) {
        let totalGrade = 0;
        let correctAnswersCount = 0;

        // Filter answers for the current number
        const results = answers.filter((element) => element.answer_number === i);

        if (results.length > 0) {
          results.forEach((el) => {
            if (el.grade !== null) {
              correctAnswersCount++;
              totalGrade += el.grade;
            }
          });

          if (correctAnswersCount > 0) {
            // Calculate weighted grade and push to grades array
            const weightedGrade = (totalGrade / correctAnswersCount) * (activity_grade / 100);
            grades.push(weightedGrade);
          }
        }
      }

      // If no grades are valid, return '-'
      if (grades.length === 0) {
        return "-";
      }

      // Return the highest grade from the list
      return Math.max(...grades).toFixed(2);
    },
    async selectType(type) {
      // this.load = true;
      this.selectedType = type;
      await this.get();
      // this.load = false;
    },
    startActivity(item) {
      this.item = {};
      if (item.type == "forum") {
        this.isShowContent = 2;
      }
      if (item.type == "short_search") {
        this.isShowContent = 3;
      }
      if (item.type == "homework") {
        this.isShowContent = 4;
      }
      if (item.type == "exam") {
        this.isShowContent = 5;
      }

      this.item = item;
    },
  },
  watch: {
    //
    activityView() {
      this.get();
    },
  },
};
</script>
